/* @flow */
// import {List} from 'csso';
import { combineReducers } from 'redux-immutable';
import { OrderedMap, fromJS, List } from 'immutable';
import type { Action } from 'trustar/utils/redux-types.js';

import {FETCH, FETCH_SUCCESS} from 'modules/templates/action-types.js';
import {
  FETCH_TEMPLATES,
  FETCH_TEMPLATES_SUCCESS,
  FETCH_TEMPLATES_FAILURE,

  FETCH_SUBSCRIPTIONS,
  FETCH_SUBSCRIPTIONS_SUCCESS,
  FETCH_SUBSCRIPTIONS_FAILURE,

  FETCH_COMPANY_SUBSCRIPTIONS,
  FETCH_COMPANY_SUBSCRIPTIONS_SUCCESS,
  FETCH_COMPANY_SUBSCRIPTIONS_FAILURE,

  ACTIVATE,
  ACTIVATE_SUCCESS,
  ACTIVATE_FAILURE,

  SET_DISPLAY_OPTIONS
} from './action-types.js';

import { Options, ManagedSubscription, type RawOptions } from './types.js';

const listToOrderedMap = (list) => {
  return fromJS(list)
    .toOrderedMap();
};

type State = OrderedMap<string, ManagedSubscription>;

export const templates = (state: State = OrderedMap(), action: Action<*>) => {
  const { type, payload } = action;
  switch (type) {
  case FETCH_TEMPLATES_SUCCESS:
    return listToOrderedMap(payload);
  default:
    return state;
  }
};

const managedSubscriptions = (state: State = OrderedMap(), action: Action<*>) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_COMPANY_SUBSCRIPTIONS_SUCCESS:
    return fromJS(payload).groupBy(x => x.get('feedGuid'));
  case ACTIVATE_SUCCESS:
    let subList = state.get(payload.feedGuid);
    return state.set(payload.feedGuid, subList.push(fromJS(payload)));
  default:
    return state;
  }
};

export const loading = (state: boolean = true, action: Action<any>) => {
  switch (action.type) {
  case FETCH_TEMPLATES:
  case FETCH_SUBSCRIPTIONS:
  case FETCH_COMPANY_SUBSCRIPTIONS:
  case ACTIVATE:
  case FETCH:
    return true;
  case FETCH_TEMPLATES_SUCCESS:
  case FETCH_TEMPLATES_FAILURE:
  case FETCH_SUBSCRIPTIONS_SUCCESS:
  case FETCH_SUBSCRIPTIONS_FAILURE:
  case FETCH_COMPANY_SUBSCRIPTIONS_SUCCESS:
  case FETCH_COMPANY_SUBSCRIPTIONS_FAILURE:
  case ACTIVATE_SUCCESS:
  case ACTIVATE_FAILURE:
  case FETCH_SUCCESS:
    return false;
  default:
    return state;
  }
};

export const options = (state: typeof Options = Options(), action: Action<RawOptions>) => {
  const { type, payload } = action;

  switch (type) {
  case SET_DISPLAY_OPTIONS:
    return state.merge(payload);
  default:
    return state;
  }
};

export default combineReducers({
  templates,
  managedSubscriptions,
  loading,
  options,
});



// WEBPACK FOOTER //
// ./src/app/modules/subscription-management/stores.js